import React from 'react';
import withModal, { WithModalProps } from 'hoc/with-modal';
import { useTranslation } from 'i18n';
import { Text } from './style';
import { ModalContent, CheckIcon } from 'routes/auth/style';
import { Row } from 'components/layout';
import { H2 } from 'components/typography';
import { CloseModalIcon } from 'components/icons';

export interface RegistrationSuccessModalProps extends WithModalProps {}

function RegistrationSuccessModal(props: RegistrationSuccessModalProps) {
  const { t } = useTranslation();

  return (
    <>
      <CloseModalIcon onClick={props.modal.hide} />
      <H2>{t('Finish registration')}</H2>
      <ModalContent>
        <Row>
          <CheckIcon />
          <Text>
            {t(
              'Your registration email has been sent. To finish up your registration verify your email address by checking your email inbox and spam folder.',
            )}
          </Text>
        </Row>
      </ModalContent>
    </>
  );
}

export default withModal(RegistrationSuccessModal);
